import styled, { css } from 'styled-components';
import { Dropdown, TreeSelect, Switch } from 'antd';

interface TitleMenuProps {
  collapsed: boolean;
}

interface ShowOptionsProps {
  showiconclose: boolean;
}

export const StyledAtendimentoIonContainer = styled.div``;

export const TreeSelectMenu = styled(TreeSelect)<ShowOptionsProps>`
  .ant-select-selection-item-remove {
    display: ${(props) => (props.showiconclose ? 'none' : 'block')};
  }
`;

export const AvatarResponsive = styled(Dropdown)`
  display: none;

  @media (max-width: 1180px) {
    display: inline;
  }

  @media (max-width: 815px) {
    display: inline;
    margin: 0% 0% 0% 0%;
  }
`;

export const AuthData = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex: 1;
  width: 100%;
`;

export const Line = styled.div`
  position: static;
  width: 100%;
  height: 0px;
  left: 24px;
  top: 523px;
  border: 1px solid #d9d9d9;
  margin-bottom: 10px;
  margin-top: 15px;
`;

export const Container = styled.div`
  .ant-scroll-number-only-unit {
    color: #fff !important;
  }

  .ant-upload-list-item-info {
    color: ${(props) => props.theme.colors.textPrimary};
    background-color: ${(props) => props.theme.colors.primary};
  }

  .anticon {
    color: ${(props) => props.theme.colors.textPrimary};
  }

  .ant-select-arrow {
    color: ${(props) => props.theme.colors.textPrimary};
    background-color: ${(props) => props.theme.colors.primary};
  }

  .liRbwP .dataatual {
    color: ${(props) => props.theme.colors.textPrimary};
  }

  strong {
    color: ${(props) => props.theme.colors.textPrimary};
  }

  p {
    color: ${(props) => props.theme.colors.textPrimary};
  }

  .hHhkEa .rbc-calendar *,
  .hHhkEa .rbc-calendar *:before,
  .hHhkEa .rbc-calendar *:after {
    background-color: ${(props) => props.theme.colors.primary};
    color: ${(props) => props.theme.colors.textPrimary};
  }

  .ant-collapse-item:last-child > .ant-collapse-content {
    background-color: ${(props) => props.theme.colors.primary};
    color: ${(props) => props.theme.colors.textPrimary};
  }

  .ant-collapse > .ant-collapse-item:last-child,
  .ant-collapse > .ant-collapse-item:last-child > .ant-collapse-header {
    background-color: ${(props) => props.theme.colors.primary};
    color: ${(props) => props.theme.colors.textPrimary};
  }

  .ant-layout-header {
    color: ${(props) => props.theme.colors.textPrimary};
  }

  .ant-input {
    background-color: ${(props) => props.theme.colors.primary};
    color: ${(props) => props.theme.colors.textPrimary};
  }

  .ant-steps,
  .ant-card-body {
    background-color: ${(props) => props.theme.colors.primary};
    color: ${(props) => props.theme.colors.textPrimary};
  }

  .ant-steps-item-process
    > .ant-steps-item-container
    > .ant-steps-item-content
    > .ant-steps-item-title {
    color: ${(props) => props.theme.colors.textPrimary};
  }

  .ant-steps-item-wait
    > .ant-steps-item-container
    > .ant-steps-item-content
    > .ant-steps-item-title {
    color: ${(props) => props.theme.colors.textPrimary};
  }

  .ant-steps-item-wait .ant-steps-item-icon > .ant-steps-icon .ant-steps-icon-dot {
    background-color: ${(props) => props.theme.colors.stepsStatus};
  }

  .ant-steps-item-finish
    > .ant-steps-item-container
    > .ant-steps-item-content
    > .ant-steps-item-title {
    color: ${(props) => props.theme.colors.textPrimary};
  }

  .ant-table tfoot > tr > th,
  .ant-table tfoot > tr > td {
    background-color: ${(props) => props.theme.colors.primary};
    color: ${(props) => props.theme.colors.textPrimary};
  }

  .ant-table-footer {
    background-color: ${(props) => props.theme.colors.primary};
    color: ${(props) => props.theme.colors.textPrimary};
  }

  .ant-table-cell-fix-left,
  .ant-table-cell-fix-right {
    background-color: ${(props) => props.theme.colors.primary};
    color: ${(props) => props.theme.colors.textPrimary};
  }

  .ant-table-thead th.ant-table-column-has-sorters:hover {
    background-color: ${(props) => props.theme.colors.hover};
  }

  .ant-table-column-sorter-up.active,
  .ant-table-column-sorter-down.active {
    color: ${(props) => props.theme.colors.hoverMenu};
  }

  tr.ant-table-expanded-row > td,
  tr.ant-table-expanded-row:hover > td {
    background-color: ${(props) => props.theme.colors.primary};
    color: ${(props) => props.theme.colors.textPrimary};
  }

  .ant-table-tbody > tr.ant-table-row:hover > td {
    background-color: ${(props) => props.theme.colors.hover};
    color: ${(props) => props.theme.colors.textPrimary};
  }

  td.ant-table-column-sort {
    background-color: ${(props) => props.theme.colors.primary};
  }

  .ant-table {
    background-color: ${(props) => props.theme.colors.primary};
  }

  .ant-table-thead > tr > th {
    background-color: ${(props) => props.theme.colors.primary};
  }

  .ant-table-row-expand-icon ::selection {
    color: ${(props) => props.theme.colors.rowExpand};
  }

  .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
    background-color: ${(props) => props.theme.colors.selectMenu};
  }

  .ant-menu-submenu-arrow {
    color: ${(props) => props.theme.colors.textPrimary};
    background-color: ${(props) => props.theme.colors.primary};
  }

  .ant-menu-item a {
    color: ${(props) => props.theme.colors.textPrimary};
  }

  .ant-menu a:hover {
    color: ${(props) => props.theme.colors.hoverMenu};
  }

  .ant-menu {
    color: ${(props) => props.theme.colors.textPrimary};
    background-color: ${(props) => props.theme.colors.primary};
  }

  .ant-btn-ghost {
    color: ${(props) => props.theme.colors.textPrimary};
  }

  .ant-select-show-search.ant-select:not(.ant-select-customize-input) .ant-select-selector input {
    color: ${(props) => props.theme.colors.textPrimary};
  }

  .ant-select-multiple .ant-select-selection-item-content {
    color: ${(props) => props.theme.colors.textPrimary};
    background-color: ${(props) => props.theme.colors.primary};
  }

  .ant-select-single .ant-select-selector .ant-select-selection-item {
    color: ${(props) => props.theme.colors.textPrimary};
  }

  .ant-avatar.ant-avatar-icon {
    color: ${(props) => props.theme.colors.primary};
    background-color: ${(props) => props.theme.colors.avatar};
  }

  .ant-table-row-expand-icon {
    color: ${(props) => props.theme.colors.textPrimary};
    background-color: ${(props) => props.theme.colors.primary};
  }

  .ant-tag {
    background-color: ${(props) => props.theme.colors.primary};
    border: ${(props) => (props.theme === 'dark' ? 'hidden' : '1px solid')};
  }

  .ant-table-tbody > tr > td {
    color: ${(props) => props.theme.colors.textPrimary};
  }

  .ant-table-thead > tr > th {
    background-color: ${(props) => props.theme.colors.headerTable};
    color: ${(props) => props.theme.colors.textPrimary};
  }

  .ant-pagination-item a {
    background-color: ${(props) => props.theme.colors.primary};
    color: ${(props) => props.theme.colors.textPrimary};
  }

  .ant-pagination-prev .ant-pagination-item-link,
  .ant-pagination-next .ant-pagination-item-link {
    background-color: ${(props) => props.theme.colors.primary};
  }

  .ant-btn[disabled] {
    color: ${(props) => props.theme.colors.btnDisable};
    background-color: ${(props) => props.theme.colors.primary};
  }

  .ant-btn[disabled]:hover {
    background-color: ${(props) => props.theme.colors.hover};
  }

  .ant-btn-dangerous.ant-btn-text {
    color: ${(props) => props.theme.colors.btnDanger};
  }

  .ant-picker {
    background-color: ${(props) => props.theme.colors.primary};
    color: ${(props) => props.theme.colors.textPrimary};
  }

  .ant-picker-input > input {
    color: ${(props) => props.theme.colors.textPrimary};
  }

  .ant-input-number-handler {
    color: ${(props) => props.theme.colors.textPrimary};
    background-color: ${(props) => props.theme.colors.primary};
  }

  .ant-select-multiple .ant-select-selection-item {
    background-color: ${(props) => props.theme.colors.primary};
  }

  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    background-color: ${(props) => props.theme.colors.inputSelect};
  }

  .input[type='text'],
  input[type='password'],
  input[type='number'],
  textarea {
    background-color: ${(props) => props.theme.colors.inputSelect};
    color: ${(props) => props.theme.colors.textPrimary};
  }

  .ant-select-clear {
    color: ${(props) => props.theme.colors.textPrimary};
    background-color: ${(props) => props.theme.colors.primary};
  }

  .ant-scroll-number-only > p.ant-scroll-number-only-unit {
    color: ${(props) => props.theme.colors.headerTable};
  }

  .header-menu {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 24px;
    position: relative;
    background-color: ${(props) => props.theme.colors.primary};
    box-shadow: 11px 0px 10px 0 rgb(29 35 41 / 40%);
  }
  .btn-show {
    display: none;
    width: 30px;
    margin: 0 auto;
  }

  .sider {
    max-height: 100vh;
    background-color: ${(props) => props.theme.colors.primary};

    overflow: auto;
    overflow-x: hidden;
    .hoverItenMenu {
      font-weight: 600;
      font-size: 16px;
      letter-spacing: 0.1px;

      &:hover {
        background: linear-gradient(to right, #e8f4f8, #fff);
        -webkit-transform: scale(1.1);
        -ms-transform: scale(1.1);
        transform: scale(1.1);
      }
    }
  }

  @media (max-width: 1180px) {
    .sider {
      display: none;
    }
  }

  @media (max-width: 815px) {
    .ant-select.ant-tree-select.ant-select-multiple.ant-select-allow-clear.ant-select-show-search {
      width: 100% !important;
    }
    .sider {
      display: none;
    }
    .btn-show {
      position: absolute;
      right: 0;
      left: 0;
      margin: 0 auto;
      text-align: center;
      top: 0;
      z-index: 1;
      display: block;
    }

    .header-menu {
      min-height: 60px;
    }
  }
`;

export const TitleMenu = styled.div<TitleMenuProps>`
  display: ${(props) => (props.collapsed ? 'none' : 'block')};
  height: 40px;
  line-height: 40px;
  padding-left: 24px;
  font-weight: bold;
  color: ${(props) => props.theme.colors.primary};
  text-transform: uppercase;
`;

export const UserData = styled.div`
  display: flex;
  line-height: 1.2;
  padding-left: 15px;
  button {
    margin-left: 8px;
  }
  @media (max-width: 1180px) {
    /* display: none; */
  }
`;

export const ContainerData = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  span:last-child {
    margin-right: 7px;
    @media (max-width: 1180px) {
      font-size: 14px;
    }
  }
`;

const UserNameLoginStyles = css`
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Username = styled.div`
  ${UserNameLoginStyles}
`;

export const Login = styled.div`
  color: #8c8c8c;
  ${UserNameLoginStyles}

  @media (max-width: 1180px) {
    display: none;
  }
`;

export const ContainerDataResponsive = styled.div`
  padding: 16px;

  button {
    padding-left: 0;
  }
`;

export const AvatarRegular = styled(Dropdown)``;

export const Content = styled.div`
  padding: 24px;
  height: calc(100vh - 64px);
  overflow: auto;
  background-color: ${(props) => props.theme.colors.contentBg};
`;

export const Div = styled.div`
  margin-top: 2px;
`;

export const SwitchTheme = styled(Switch)`
  margin-left: 1%;
`;
